<template>
  <c-view>
    <c-page class="under-bg">
      <c-content>
        <div class="text-center active-success">
          <div class="success-icon"><i class="success-color s-icon-check-circle-success"></i></div>
          <div class="success-color font-lg">激活成功</div>
          <div class="mt-15 text-color gray font-md">请推荐用户扫描收款码，进行付款。</div>
        </div>
      </c-content>
      <div class="footer-container">
        <info-footer></info-footer>
      </div>
    </c-page>
  </c-view>
</template>
<style lang="scss" scoped>
  @import './index.scss';
</style>
<script>
  import InfoFooter from '../../info-footer'

  export default {
    data () {
      return {}
    },
    components: {
      InfoFooter
    },
    created () {
    },
    mounted () {
    },
    beforeDestroy () {
    },
    methods: {},
    computed: {},
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?0b6d4d7f